// extracted by mini-css-extract-plugin
export default {"IconTick":"IconTickSvg_IconTick__fAWDR"};